
/* injects from baggage-loader */

/* globals Editor */
/* jshint browser: true */
'use strict';

const moduleDialogEditorBlock = angular.module('services.layoutEditor.blockEditDialog', ['services.editorNamespace']);

moduleDialogEditorBlock.factory('blockEditDialog', [
  '$timeout', '$injector', 'ns', 'Widget', 'Parallax', 'ContentAnimate', 'bgSlideShow', '$filter', 'Template',
  ($timeout, $injector, ns, Widget, Parallax, ContentAnimate, bgSlideShow, $filter, Template) => {
    let Y;

    const blockEditDialog = {
      currentBlock: undefined,
      currentBlockJson: undefined,
      scopeApply: function() {
        return $(ns.settingsWindowClass).scope().$apply();
      },
      setYUI: function(y) {
        Y = y;
      },
      init: function(y) {
        this.setYUI(y);
      },
      _onChangeWidget: function(newVal) {
        const self = this;

        this.currentBlock.one(ns.widgetWrapperClass).setStyles(newVal.style_attributes);
        switch (newVal.type) {
          case 'line':
            this._onLineChange(newVal);
            break;
          case 'button':
            this._onButtonChange(newVal);
            this._onButtonTwoChange(newVal);
            break;
          case 'video':
            this._onVideoChange(newVal, newVal);
            if (newVal.use_button) {
              this._onButtonChange(newVal);
            }
            break;
          case 'review':
            newVal.photos_attributes.forEach(function(photo) {
              if (photo.media_type === 'video') {
                self._onVideoChange(photo, newVal, '[data-slide-id=\'' + photo.id + '\'] .strw-review__video');
              }
            });
            break;
          case 'search':
            this._onSearchChange(newVal);
            break;
          case 'list':
            this._onListChange(newVal);
        }

        this.currentBlock.widget = newVal;
      },
      _onListChange: function(newVal) {
        const list = this.currentBlock.one('ul.strbw_list');
        const bullets = list.all('li');
        const bulletsCaption = list.all('.strbw_list-item__caption');
        const paddingSplit = newVal.caption_style.padding.split(' ');
        const {border, color, fontFamily, fontSize, fontWeight, padding, borderRadius, backgroundColor} = newVal.caption_style;

        list.setStyles({backgroundColor, borderRadius, border});
        bulletsCaption.setStyles({padding, color, fontFamily, fontWeight});
        bullets.setStyles({
          fontSize,
          borderBottom: border,
          backgroundImage: 'url(' + newVal.image_attributes.source_url + ')',
          backgroundPosition: `${paddingSplit[3]} ${paddingSplit[0]}`
        });

        if (newVal.icon) {
          if (newVal.icon.cssClass) {
            if (!list.hasClass('strbw_list_icon')) {
              list.addClass('strbw_list_icon');
            }
          } else {
            if (list.hasClass('strbw_list_icon')) {
              list.removeClass('strbw_list_icon');
            }
          }

          bullets.each((block) => {
            this.updateList(
              $(block._node),
              Object.assign(newVal.icon, {
                top: paddingSplit[0],
                left: paddingSplit[3]
              })
            );
          });
        }

        const themes = ['none', 'strip', 'frame'];
        themes.map((item) => {
          if (list.hasClass(`strbw_list_${item}`)) {
            list.removeClass(`strbw_list_${item}`);
          }
        });

        if (newVal.theme) {
          list.addClass(`strbw_list_${newVal.theme}`);
        }
      },
      /**
       * Обновление списка
       * @param $list
       * @param iconAttributes
       */
      updateList: function($list, iconAttributes) {
        const {cssClass, color, backgroundColor, top, left} = iconAttributes;
        const iconNode = $list.find('.strbw_list__icon');

        // Очистим кнопку от всех элементов
        if (iconNode.length > 0) {
          iconNode.remove();
        }

        // Установка иконки, если она есть
        if (cssClass) {
          const iconNode = $(`<i class="strbw_list__icon ${cssClass}"></i>`);

          iconNode.attr('contenteditable', 'false');
          iconNode.css({color, backgroundColor, top, left});
          $list.prepend(iconNode);
        }
      },
      _onSearchChange: function(newVal) {
        this.currentBlock.one('.strw__search-icon').setStyles(newVal.icon_style_attributes);
        this.currentBlock.one(ns.widgetSearchInputClass).setStyles(newVal.input_style_attributes);
      },
      /**
       * Изменение параметров кнопки
       * @param newVal
       * @private
       */
      _onButtonChange: function(newVal) {
        const styles = newVal.button_attributes.style_attributes;
        const button = this.currentBlock.one(ns.widgetButtonClass);

        button.setStyles(styles);
        button.setAttribute('href', '#');
        button.setAttribute('onclick', '');

        this.updateBtn($(button._node), newVal.button_attributes);
      },
      /**
       * Изменение параметров второй кнопки
       * @param newVal
       * @returns {boolean}
       * @private
       */
      _onButtonTwoChange: function(newVal) {
        const buttonTwo = this.currentBlock.one(ns.widgetButtonTwoClass);
        const styles = newVal.button_two_attributes.style_attributes;

        if (newVal.button_type === 'one') {
          buttonTwo.setStyles({display: 'none'});
          return false;
        }

        buttonTwo.setStyles({display: 'inline-block'});
        buttonTwo.setStyles(styles);
        buttonTwo.setAttribute('href', '#');
        buttonTwo.setAttribute('onclick', '');

        this.updateBtn($(buttonTwo._node), newVal.button_two_attributes);
      },
      /**
       * Обновление кнопки
       * @param $button
       * @param buttonAttributes
       */
      updateBtn: function($button, buttonAttributes) {
        const {icon, additional_text} = buttonAttributes;
        const iconNode = $button.find('.strwf_button__icon');
        const additionalTextNode = $button.find('.strwf_button__additional-text');

        // Очистим кнопку от всех элементов
        if (iconNode.length > 0) {
          iconNode.remove();
        }
        if (additionalTextNode.length > 0) {
          additionalTextNode.remove();
        }

        // Установка иконки, если она есть
        if (icon) {
          const iconNode = $(`<i class="strwf_button__icon ${icon}"></i>`);

          iconNode.attr('contenteditable', 'false');
          $button.prepend(iconNode);
        }

        // Установка доп. текста, если он есть
        if (additional_text && additional_text.title) {
          const {title, color, fontSize, fontFamily, fontWeight} = additional_text;
          const additionalTextNode = $(`<span class="strwf_button__additional-text">${title || ''}</span>`);

          additionalTextNode.css({color, fontSize, fontFamily, fontWeight});
          additionalTextNode.attr('contenteditable', 'false');
          $button.append(additionalTextNode);
        }
      },
      _onLineChange: function(newVal) {
        const styles = {
          'height': newVal.height,
          'background-color': newVal.background_color,
          'color': newVal.background_color,
          'width': newVal.width
        };

        this.currentBlock.all(ns.widgetLineClass).setStyle('text-align', newVal.style_attributes.textAlign);
        this.currentBlock.all(ns.widgetLineContentClass).setStyles(styles);
        this.currentBlock.one(ns.widgetWrapperClass).setStyles({color: newVal.background_color});
      },
      _onVideoChange: function(newVal, widget, videoSelector) {
        if (videoSelector === null || videoSelector === undefined) {
          videoSelector = '.strwvideo';
        }

        const self = this;
        const sectionId = this.getSectionId(widget);

        Widget.getVideoHtml(sectionId, newVal.video_url).then(function(video) {
          let srcEq, videoHTMLparse;

          if (self.currentBlock.one('iframe') && widget.type === 'video') {
            srcEq = self.currentBlock.one('iframe').getAttribute('src') === $(video.html).find('iframe').attr('src');
          }

          if (srcEq) {
            return false;
          }

          if (widget.type === 'review') {
            videoHTMLparse = $('<div>' + video.html + '</div>').find('.strwvideo__iframe').html();
          } else {
            videoHTMLparse = $('<div>' + video.html + '</div>').find('.strwvideo').html();
          }

          self.currentBlock.one(videoSelector).setHTML(videoHTMLparse);
        });

        if (widget.type === 'video') {
          if (newVal.use_button) {
            this.currentBlock.one(videoSelector).setStyles({display: 'none'});
            this.currentBlock.one(ns.widgetButtonClass).setStyles({display: 'inline-block'});
          } else {
            this.currentBlock.one(videoSelector).setStyles({display: 'block'});
            this.currentBlock.one(ns.widgetButtonClass).setStyles({display: 'none'});
          }
        }
      },
      transformImageToBgUrl: function(url) {
        return 'url(' + url + ')';
      },
      sectionRemoveStyle: function(newVal) {
        Y.one('[data-section-id=\'' + newVal.id + '\']').setStyles(newVal.style_attributes);
      },
      sectionSaveTimeout: undefined,
      setGradient: function(section) {
        const color_start = section.background_attributes.color_start;
        const color_stop = section.background_attributes.color_stop;
        const gradient_css = 'background-image:-moz-linear-gradient(top, ' + color_start + ', ' + color_stop + '); background-image:-webkit-linear-gradient(top, ' + color_start + ', ' + color_stop + '); background-image:-o-linear-gradient(top, ' + color_start + ', ' + color_stop + '); background-image:-ms-linear-gradient(top, ' + color_start + ', ' + color_stop + ');, background-image:linear-gradient(top, ' + color_start + ', ' + color_stop + '); filter: progid:DXImageTransform.Microsoft.gradient(startColorStr=\'' + color_start + '\', endColorstr=\'' + color_stop + '\');';

        if ($('style#' + section.id).length > 0) {
          $('style#' + section.id).html('.ls_' + section.id + ':before { ' + gradient_css + ' }');
        } else {
          $('body').append('<style id=\'' + section.id + '\'>.ls_' + section.id + ':before { ' + gradient_css + ' }</style>');
        }
      },
      removeGradient: function(section) {
        if ($('style#' + section.id).length > 0) {
          $('style#' + section.id).html('.ls_' + section.id + ':before { background-image:none; }');
        } else {
          $('body').append('<style id=\'' + section.id + '\'>.ls_' + section.id + ':before { background-image:none; }</style>');
        }
      },
      setEffectStyles: function(newVal) {
        if (newVal.background_attributes.parallax) {
          Parallax.initSection(this.currentBlock);
        } else {
          Parallax.destroy(this.currentBlock);
        }
        if (newVal.background_attributes.gradient) {
          this.setGradient(newVal);
        } else {
          this.removeGradient(newVal);
        }
      },
      setBackgroundSlider: function(section) {
        const css = 'background-color: ' + section.style_attributes.backgroundColor + '; content: \'\'; z-index: 2; position: absolute; width: 100%; height:100%; top:0; left:0;';
        if ($('style#' + section.id + '-slider').length > 0) {
          $('style#' + section.id + '-slider').html('.ls_' + section.id + ' > .swiper-container:before { ' + css + ' }');
        } else {
          $('body').append('<style id=\'' + section.id + '-slider\'>.ls_' + section.id + ' > .swiper-container:before { ' + css + ' }</style>');
        }
      },
      setBackground: function(section, old_section) {
        bgSlideShow.destroy(this.currentBlock);

        switch (section.background_attributes.type) {
          case 'image':
            this.currentBlock.all('.section__video-bg').remove();
            const bgImagesLength = section.background_attributes.images_attributes.length;
            if (bgImagesLength === 0) {
              section.style_attributes['backgroundImage'] = 'none';
            }
            if (bgImagesLength === 1) {
              const firstImage = section.background_attributes.images_attributes[0].url;
              section.style_attributes['backgroundImage'] = this.transformImageToBgUrl(firstImage);
            }
            if (bgImagesLength > 1) {
              bgSlideShow.initSection(this.currentBlock, section.style_attributes);
              this.setBackgroundSlider(section);
            }
            break;
          case 'video':
            const coverUrl = section.background_attributes.video_cover_url;
            const mp4Url = section.background_attributes.video_mp4_url;
            const oldmp4Url = old_section.background_attributes.video_mp4_url;
            const newType = section.background_attributes.type;
            const oldType = old_section.background_attributes.type;
            const loaderUrl = '/assets/images/pattern-squares.png';

            if (mp4Url === oldmp4Url && newType === oldType && this.currentBlock.all('.section__video-bg').size() > 0) {
              return false;
            }

            if (!mp4Url) {
              this.currentBlock.all('.section__video-bg').remove();
            } else {
              section.style_attributes['backgroundColor'] = 'rgba(255, 255, 255, 0)';
              this.currentBlock.prepend(
                  '<div class=\'section__video-bg\'>' +
                    '<video class=\'section__video-element\' loop=\'\' muted=\'\' autoplay=\'autoplay\' poster=\'' + (coverUrl || loaderUrl) + '\'>' +
                      '<source src=\'' + mp4Url + '\' type=\'video/mp4\'>' +
                    '</video>' +
                  '</div>'
              );
              section.style_attributes['backgroundImage'] = 'none';
            }
        }
      },
      sectionContentCenter: function(newVal) {
        if (newVal.style_attributes.minHeight === '100vh') {
          this.currentBlock.one(ns.wrapperClass).addClass('str-wrapper_vertical-center');
        } else {
          this.currentBlock.one(ns.wrapperClass).removeClass('str-wrapper_vertical-center');
        }
      },
      _onChangeSection: function(newVal, oldVal) {
        if (!angular.equals(newVal, oldVal)) {
          this.currentBlock.old_section = oldVal;
        }

        const layoutEditor = $injector.get('layoutEditor');
        const Slider = $injector.get('Slider');

        newVal = angular.copy(newVal);
        this.setBackground(newVal, oldVal);

        if (newVal.background_attributes.type === 'video') {
          newVal.style_attributes['backgroundImage'] = 'none';
        }

        if (Editor.mode === 'email.page.editor' || Editor.mode === 'form.page.editor') {
          this.currentBlock.setStyles(newVal.wrapper_style_attributes);
          this.changeBgType(newVal);
        }

        this.currentBlock.setStyles(newVal.style_attributes);

        if (newVal.background_attributes.images_attributes.length === 1) {
          this.currentBlock.setStyles({
            backgroundImage: 'url(' + newVal.background_attributes.images_attributes[0].source_url + ')'
          });

          if (!angular.equals(newVal.background_attributes.images_attributes, oldVal.background_attributes.images_attributes)) {
            Template.getStylesheet().then(function(response) {
              angular.element('#tplStyles').text(response);
            });
          }
        }

        this.currentBlock.one(ns.wrapperClass).setStyles(newVal.wrapper_style_attributes);
        Slider.updateSliders();

        this.sectionContentCenter(newVal);
        this.currentBlock.section = newVal;
        this.setEffectStyles(newVal);
        this.currentBlock.section = newVal;
      },
      changeBgType: function(newVal) {
        if (newVal.bg_type === 'image') {
          if (newVal.background_attributes.images_attributes.length > 0) {
            newVal.style_attributes['backgroundColor'] = 'rgba(255, 255, 255, 0)';
            newVal.style_attributes['backgroundImage'] = 'url(' + newVal.background_attributes.images_attributes[0].url + ')';
          }
        }

        if (newVal.bg_type === 'color') {
          newVal.style_attributes['backgroundImage'] = 'none';
        }

        newVal.style_attributes['maxWidth'] = newVal.wrapper_style_attributes.maxWidth;
      },
      setPanelTitle: function(blockJson) {
        let newVal;

        if (this.currentBlockType === 'section') {
          newVal = ($filter('translate')('editor.section')) + ' «' + blockJson.title + '»';
          if (Editor.mode === 'form.page.editor') {
            newVal = '' + ($filter('translate')('editor.section.panelSettingsLabel'));
          }
        }
        if (this.currentBlockType === 'widget') {
          newVal = ($filter('translate')('editor.widget')) + ' «' + blockJson.name + '»';
        }

        Y.one('.etsw-header__title').setHTML(newVal);
      },
      setBlock: function(e) {
        this.currentBlock = this.findBlockOrSection(e);
        this.currentBlockJson = this.currentBlock[this.currentBlockType];
      },
      getWidgetSettings: function() {
        return this.currentBlock.widget;
      },
      getSectionSettings: function() {
        return this.currentBlock.section;
      },
      getBlockId: function(e) {
        const node = e.target;
        const block = node.ancestor(ns.blockClass);
        const section = node.ancestor(ns.sectionClass) || node;

        if (block) {
          return block.widget.id;
        } else {
          return section.section.id;
        }
      },
      findBlockOrSection: function(e) {
        const node = e.target;
        const block = node.ancestor(ns.blockClass);
        const section = node.ancestor(ns.sectionClass) || node;

        if (block) {
          this.currentBlockType = 'widget';
          return block;
        } else {
          this.currentBlockType = 'section';
          return section;
        }
      },
      clearCurrentBlockJson: function() {
        this.currentBlockJson = undefined;
      },
      getSectionId: function(widget) {
        const sectionEl = Y.one('[data-block-id=\'' + widget.id + '\']').ancestor(ns.sectionClass);
        const sectionId = sectionEl.section.id;

        return sectionId;
      },
      destroy: function() {
        if (this.dd) {
          this.dd.destroy();
        }
        if (this.dd) {
          this.dd._unprep();
        }
      }
    };

    return blockEditDialog;
  }
]);



// WEBPACK FOOTER //
// ./src/app/editor/services/layout_editor/blockEditDialog.js